import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import * as util from '../../utils/urlParams';
import { DiagnosticsActions, UtilityActions } from '../../store';
import './SelectFilter.css';

export class SelectFilter extends Component {
  handleChange = (filter) => {
    const {
      navigationParams: {
        selectedCategory: { id: categoryId },
        selectedSubCategory,
      },
      location,
      updateDiagnosticsGraphDateRange,
      updateElectricalGraphDateRange,
      updateGasGraphDateRange,
    } = this.props;
    const { search } = location;

    let newSearch = '';
    let customDataPoints = JSON.parse(window.sessionStorage.getItem('customDataPoints')) || {};

    const customDataPointsForSubCategory = customDataPoints[selectedSubCategory.id] || [];

    if (filter.value === 'custom') {
      return this.props.onCustomClick();
    } else if (selectedSubCategory.id === 'suite_graphs') {
      const thermostat = util.getThermostatFromUrlParams(search);
      const selectedDataPoints = util.getDataPointsFromUrlParams(search);

      newSearch = util.addThermostatSearchParams(filter, thermostat, selectedDataPoints);
    } else {
      newSearch = util.addSearchParams(filter, customDataPointsForSubCategory);
    }

    this.props.history.push(`${selectedSubCategory.url}?${newSearch}`);

    switch (categoryId) {
      case 'electrical-usage':
        return updateElectricalGraphDateRange(filter);
      case 'gas-usage':
        return updateGasGraphDateRange(filter);
      case 'diagnostics':
        return updateDiagnosticsGraphDateRange(filter);
      default:
        return updateElectricalGraphDateRange(filter);
    }
  };

  render() {
    const {
      diagGraphDateRange,
      electricalGraphDateRange,
      gasGraphDateRange,
      navigationParams: {
        selectedCategory: { id: categoryId, name },
      },
    } = this.props;

    const filterOptions =
      categoryId === 'electrical-usage' || categoryId === 'gas-usage'
        ? util.SAVINGS_FILTER_OPTIONS
        : util.FILTER_OPTIONS;

    let graphDateRange;
    switch (categoryId) {
      case 'electrical-usage':
        graphDateRange = electricalGraphDateRange;
        break;
      case 'gas-usage':
        graphDateRange = gasGraphDateRange;
        break;
      case 'diagnostics':
        graphDateRange = diagGraphDateRange;
        break;
      default:
        graphDateRange = diagGraphDateRange;
        break;
    }

    return (
      <React.Fragment>
        <Select
          name="date-range"
          value={graphDateRange}
          onChange={this.handleChange}
          isSearchable={false}
          options={filterOptions}
          className={name === 'Thermostat' ? 'date-range-select date-range-select__thermostat' : 'date-range-select'}
          classNamePrefix="date-range-select"
        />
      </React.Fragment>
    );
  }
}

SelectFilter.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  onCustomClick: PropTypes.func.isRequired,
  navigationParams: PropTypes.shape({
    selectedCategory: PropTypes.shape({
      api_location: PropTypes.string,
      url: PropTypes.string,
      name: PropTypes.string,
      image: PropTypes.string,
      sub_categories: PropTypes.arrayOf(
        PropTypes.shape({
          api_location: PropTypes.string,
          data_api_location: PropTypes.string,
          id: PropTypes.string,
          url: PropTypes.string,
          name: PropTypes.string,
        }),
      ),
    }),
    selectedSubCategory: PropTypes.shape({
      api_location: PropTypes.string,
      data_api_location: PropTypes.string,
      id: PropTypes.string,
      url: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
};

SelectFilter.defaultProps = {
  navigationParams: {
    selectedCategory: {},
    selectedSubCategory: {},
  },
};

function mapStateToProps(state) {
  return {
    navigationParams: state.buildingReducer.navigationParams,
    selectedDataPoints: state.suiteReducer.selectedSuiteDataPoints,
    diagGraphDateRange: state.diagnosticsReducer.graphDateRange,
    electricalGraphDateRange: state.utilityReducer.electricalGraphDateRange,
    gasGraphDateRange: state.utilityReducer.gasGraphDateRange,
  };
}

const mapDispatchToProps = {
  updateDiagnosticsGraphDateRange: DiagnosticsActions.updateDiagnosticsGraphDateRange,
  updateElectricalGraphDateRange: UtilityActions.updateElectricalGraphDateRange,
  updateGasGraphDateRange: UtilityActions.updateGasGraphDateRange,
};

const ConnectedSelectFilter = connect(mapStateToProps, mapDispatchToProps)(SelectFilter);
const ConnectedSelectFilterWithRouter = withRouter(ConnectedSelectFilter);

export { ConnectedSelectFilterWithRouter };
